/* =========================================================================
   Achievements (display-side) — mirrors the prototype. Break-award achievements
   are collected during a session (deduped by name) and shown on the results
   screen. In production the server is the authority for the persisted catalog
   (POST /api/game/complete returns earned achievements); this local set drives
   the celebratory UI and matches the server's rules.
   ========================================================================= */
import type { Achievement, GameState } from './context';

/** The prototype's seed catalog — the same seven the plan carries into the DB. */
export const ACHIEVEMENT_CATALOG: Achievement[] = [
  { icon: '🌹', name: 'Crown of Roses', desc: 'Completed all three tiers of the Mother Mary Match-3' },
  { icon: '🎡', name: 'BINGO!', desc: 'Hit the $2,000 jackpot on the Bonus Wheel' },
  { icon: '⚡', name: 'Lightning Hands', desc: 'Filled the manna basket in under 5 seconds' },
  { icon: '🌊', name: 'Heavenly Cascade', desc: 'Cleared 8+ gifts in a single cascade' },
  { icon: '☕', name: 'Holy Coffee', desc: 'Blessed with the rare cup on the Bonus Wheel' },
  { icon: '🤧', name: 'Bless You!', desc: 'Caught the rare saintly sneeze blessing' },
  { icon: '✨', name: 'Perfect Round', desc: 'Every question right in a round' },
];

/** Record a break-award achievement on the given game state. Deduped by name. */
export function addAchievement(game: GameState, icon: string, name: string, desc: string): void {
  if (!game.achievements) game.achievements = [];
  if (game.achievements.some((a) => a.name === name)) return;
  game.achievements.push({ icon, name, desc });
}

/** Map a display name to the server catalog's stable Key (app.Achievements.[Key]) —
    the summary endpoint grants by key via usp_Achievement_Grant. */
const NAME_TO_KEY: Record<string, string> = {
  'Crown of Roses': 'crown_of_roses',
  'BINGO!': 'wheel_bingo',
  'Lightning Hands': 'lightning_hands',
  'Heavenly Cascade': 'heavenly_cascade',
  'Holy Coffee': 'holy_coffee',
  'Bless You!': 'bless_you',
};
export function serverKeyFor(name: string): string | null {
  if (name.startsWith('Perfect Round')) return 'perfect_round';   // per-round names collapse to one key
  return NAME_TO_KEY[name] ?? null;
}
